import $ from 'jquery';
const queryString = require('query-string');

// Updates the idea_portal with attribute and value derived from the event. The event is also used to determine
// where to display the error and saving messages. Additional options can be provided:
// * attributes - Hash of attributes and values to use instead of the attribute/value derived from the event
// * params - Sent along with the request but are not part of the idea_portal attributes
// * onSuccess - Function to call on success
// * onError - Function to call on error
function savePortal(event, options = {}) {
  const attributes = options['attributes'] || buildAttributes(event);
  const params = options['params'];
  const onSuccess = options['onSuccess'];
  const onError = options['onError'];
  const errorElement = $(event.target.closest('.control'))
    .find('.errors')
    .text('');
  const warningElement = $(event.target.closest('.control'))
    .find('.warnings')
    .text('');
  const savingElement = saving(event);

  $.ajax({
    url: location.href,
    type: 'PUT',
    data: JSON.stringify({
      ideas_idea_portal: attributes,
      ...params,
    }),
    dataType: 'json',
    contentType: 'application/json',
    success: response => {
      saved(savingElement);
      if (onSuccess) onSuccess(response);
      if (response.warning) warningElement.text(response.warning);
    },
    error: response => {
      savingElement.text('');
      if (response.responseJSON?.errors)
        errorElement.text(response.responseJSON.errors[0]);
      else
        errorElement.text(
          'Something went wrong. Please try again, or contact support@aha.io for assistance.'
        );
      if (onError) onError(response);
    },
  });
}

// Updates the idea_portal with the given idea_portal_string. If the stringIdentifier already exists in the idea_portal
// it will update, otherwise create. Used for terminology and email templates which are stored as idea_portal_strings.
function savePortalString(event, stringIdentifier, locale, newVal) {
  savePortal(event, {
    attributes: {
      idea_portal_strings_attributes: [
        {
          string_identifier: portalStringElement(
            stringIdentifier,
            'string_identifier'
          ).val(),
          locale: locale,
          value: newVal,
        },
      ],
    },
    onSuccess: response => {
      if (
        stringIdentifier ===
        'views.idea_portal.interface.comment_creator_and_internal_users_only'
      )
        window.AhaAnalytics.track(
          'Feature-7177092895517566440',
          'User sets private portal comment terminology'
        );
    },
  });
}

// attr can be 'string_identifier' or 'value', which are attributes of idea_portal_string in the database
// We're not using 'id' as an attribute in the UI because we can uniquely identify the portal_string by
// it's string_identifier and locale.
function portalStringElement(stringIdentifier, attr) {
  return findElementForField(
    `ideas_idea_portal[idea_portal_strings_attributes][${stringIdentifier}][${attr}]`
  );
}

// Message to show while attempting to save
function saving(event, message = 'Saving…') {
  return $(event.target.closest('.panel'))
    .find('.saving')
    .stop()
    .css('opacity', 1)
    .addClass('pull-right')
    .text(message);
}

// Message to show after successful save
function saved(savingElement, message = 'Saved!') {
  savingElement.text(message).fadeTo(3000, 0, () => savingElement.text(''));
}

// Derive attribute and value from the event
function buildAttributes(event) {
  const attributeName = findAttributeName(event);
  const value =
    event.target.type === 'checkbox'
      ? event.target.checked
      : event.target.value;
  return { [attributeName]: value };
}

// Find the attribute name from within the event. For radio button, trim off the last part to get the
// attribute name (e.g., consent_enabled_false becomes consent_enabled).
function findAttributeName(event) {
  let attr = event.target.id;
  if (event.target.type === 'radio')
    attr = attr.substring(0, attr.lastIndexOf('_'));
  return attr;
}

// Find element given field name when element might be input, textarea, etc. Returns empty element if none found.
// Specify the types in the order you want to check them.
function findElementForField(fieldName, types = ['input', 'textarea']) {
  let element;
  let result;
  types.forEach(type => {
    element = $(`${type}[name="${fieldName}"]`);
    if (element.length > 0) {
      result = element;
      return false;
    }
  });
  return result || $();
}

const updateQueryParams = newParams => {
  const newQueryString = queryString.stringify({
    ...queryString.parse(window.location.search),
    ...newParams,
  });
  location.href = `${location.pathname}?${newQueryString}`;
};

// Auto select text to make it easier to copy to clipboard (e.g., copy script to embed portal)
function selectText(text) {
  if (window.getSelection) {
    const selection = window.getSelection();
    const range = document.createRange();
    range.selectNodeContents(text);
    selection.removeAllRanges();
    selection.addRange(range);
  }
}

function sendTestEmail(emailType, locale) {
  return event => {
    const target = $(event.target);
    if (target.hasClass('disabled')) return;

    const savingElement = saving(event, 'Sending email…');
    target.prop('disabled', true).addClass('disabled');

    $.ajax({
      url: location.pathname + '/send_test_email',
      type: 'POST',
      data: JSON.stringify({
        send_test_email: { email_type: emailType, locale: locale },
      }),
      dataType: 'json',
      contentType: 'application/json',
    }).always(response => {
      target.prop('disabled', false).removeClass('disabled');
      saved(savingElement, 'Email sent!');
    });
  };
}

export {
  savePortal,
  sendTestEmail,
  savePortalString,
  portalStringElement,
  updateQueryParams,
  selectText,
  saving,
  saved,
  buildAttributes,
};
